import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserInfo } from './user-info';

@Injectable()
export class UcrSecurityService {
    get isLoggedIn(): boolean {
        return this._isLoggedIn;
    }

    set isLoggedIn(val: boolean) {
        const isChanged: boolean = this._isLoggedIn !== val;
        this._isLoggedIn = val;

        if (isChanged) {
            this.onLoggedInStatusChanged.next(this._isLoggedIn);
            const redirectUrl = this.getRedirectUrl();
            if (redirectUrl) {
                this.router.navigate([redirectUrl]);
                this.removeRedirectUrl();
            }
        }
    }
    _isLoggedIn = false;
    onLoggedInStatusChanged = new ReplaySubject<boolean>(1); // new EventEmitter<boolean>();

    userInfoObservable: Observable<UserInfo>;

    constructor(public http: HttpClient, public router: Router) {
        this.onLoggedInStatusChanged.next(this._isLoggedIn);
    }
    private userInfo$: ReplaySubject<UserInfo> = new ReplaySubject(1);

    getRedirectUrl(): string {
        return localStorage.getItem('redirectUrl');
    }

    getUserInfo(bypassCache = false): Observable<UserInfo> {
        // if this is the first observer or forcibly bypass cache
        if (!this.userInfo$.observers.length || bypassCache) {
            this.http
                .get<UserInfo>('/api/ucrUserInfo')
                .pipe(
                    map((data) => {
                        const ui: UserInfo = new UserInfo(data);
                        this.isLoggedIn = !!ui.username;

                        return ui;
                    })
                )
                .subscribe(
                    (ui: UserInfo) => {
                        this.userInfo$.next(ui);
                    },
                    (error) => {
                        this.userInfo$.error(error);

                        // after an error the data won't emit anymore so recreated the subject
                        this.userInfo$ = new ReplaySubject(1);
                    }
                );
        }

        return this.userInfo$;
    }

    login(redirectUrl: string = null): void {
        const redirectTo = redirectUrl ? redirectUrl : this.router.url;
        this.saveRedirectUrl(redirectTo);
        this.router.navigate(['/login']);
    }

    logout(): void {
        this.isLoggedIn = false;
        this.http.get('/logoff').subscribe();
        this.userInfo$.next(new UserInfo(undefined));
        this.router.navigate(['/logout']);
    }

    removeRedirectUrl(): void {
        localStorage.removeItem('redirectUrl');
    }

    saveRedirectUrl(url: string): void {
        if (url !== '/logout') {
            localStorage.setItem('redirectUrl', url);
        } else {
            this.removeRedirectUrl();
        }
    }

    switchBack(): void {
        window.location.href = '/logout/impersonate';
    }

    validate(): Observable<any> {
        return this.http.get('/api/validate');
    }
}